import { ApiEndpoints } from "@shared/api/api-endpoints";
import { bxApiClient, cxApiClient } from "@shared/api/clients/apiClientFactory";
import { QueryStringParameters } from "@shared/api/url-builder";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";

export const getSingleBills = async (
  queryParams?: Record<string, any>
): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    "bills-search",
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toString());
      qs.push("get_single_bills", "true");
      if (queryParams) {
        Object.entries(queryParams).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            if (Array.isArray(value)) {
              if (value.length > 0) {
                qs.push(key, value.join(","));
              }
            } else {
              qs.push(key, value.toString());
            }
          }
        });
      }
    }
  );
  const response = await bxApiClient.get(url);
  return response.data;
};

export const getBillCycleList = async (
  queryParams: Record<string, any>
): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();

  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    "bill-run",
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
      qs.push("extra_detail", 1);

      Object.entries(queryParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          qs.push(key, String(value));
        }
      });
    }
  );

  const response = await bxApiClient.get(url);
  return response.data;
};

export const getSingleBillDraft = async (page: number): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();

  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    "old/get-draft-bills",
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
      qs.push("page", page);
      qs.push("type_of", "Single");
    }
  );

  const response = await bxApiClient.get(url);
  return response.data;
};

export const getHistorySummary = async (): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();

  const url = ApiEndpoints.createUrlWithQueryParameters(
    "cx",
    "outstanding/summary",
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
    }
  );

  const response = await cxApiClient.get(url);
  return response.data.result;
};

export const getBulkBillDraft = async (page: number): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();

  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    "old/get-draft-bills",
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
      qs.push("type_of", "Bulk");
    }
  );

  const response = await bxApiClient.get(url);
  return response.data;
};

export const getBillCycleOptions = async (): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `run-list-dropdown`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
    }
  );
  const response = await bxApiClient.get(url);

  const data = response.data?.result;
  return data.map((item: any) => ({
    id: item.id,
    name: item.name,
  }));
};
